import { eTitleFees } from './eTitleFees';

export const TitleFeesThatGoInSectionH = [
  eTitleFees.cpl_seller,
  eTitleFees.standard_owners_policy,
  eTitleFees.homeowners_policy,
  eTitleFees.tieff_owners_policy,
  eTitleFees.owners_policy_guaranty,
  eTitleFees.owners_state_policy,
  eTitleFees.owners_title_guaranty,
];
